import { cn } from "../lib/cn";

export interface AlertProps {
  variant: "success" | "warning" | "error";
  title: string;
  children?: React.ReactNode;
  className?: string;
}

const variantStyles = {
  success: {
    bg: "bg-[var(--color-success-bg)]",
    title: "text-gold",
    icon: "\u2713",
  },
  warning: {
    bg: "bg-[var(--color-warning-bg)]",
    title: "text-amber",
    icon: "!",
  },
  error: {
    bg: "bg-[var(--color-error-bg)]",
    title: "text-[var(--color-error-text)]",
    icon: "\u2717",
  },
};

export function Alert({ variant, title, children, className }: AlertProps) {
  const styles = variantStyles[variant];

  return (
    <div
      role="alert"
      className={cn("octa-sm flex gap-3 p-4", styles.bg, className)}
    >
      <span className={cn("shrink-0 text-sm", styles.title)} aria-hidden="true">
        {styles.icon}
      </span>
      <div className="flex flex-col gap-1">
        <span
          className={cn(
            "font-mono text-[11px] uppercase tracking-[0.12em]",
            styles.title,
          )}
        >
          {title}
        </span>
        {children && (
          <div className="text-text-muted font-mono text-[10px] tracking-[0.04em]">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
